import { Helmet } from 'react-helmet-async'
import Section from '../components/common/Section'

export default function DatenschutzPage() {
  return (
    <>
      <Helmet>
        <title>Datenschutz - Gabriele Wiedemann</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Section>
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-serif text-primary mb-8">Datenschutzerklärung</h1>

          <div className="prose prose-neutral max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">1. Datenschutz auf einen Blick</h2>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Allgemeine Hinweise</h3>
              <p className="mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
              <p className="mb-4">
                Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem
                Text aufgeführten Datenschutzerklärung.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">2. Verantwortliche Stelle</h2>
              <p className="mb-4">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mb-4">
                <strong>Gabriele Wiedemann</strong>
                <br />
                Künstlerin
                <br />
                Kaiserstuhl
                <br />
                Deutschland
              </p>
              <p className="mb-4">
                <strong>E-Mail:</strong> <a href="mailto:info@gwiedemann.de" className="text-primary hover:text-secondary">info@gwiedemann.de</a>
                <br />
                <strong>Telefon:</strong> <a href="tel:+4915123602627" className="text-primary hover:text-secondary">+49 151 23602627</a>
              </p>
              <p className="mb-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
                Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">3. Datenerfassung auf dieser Website</h2>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Kontaktformular</h3>
              <p className="mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p className="mb-4">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
                vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die
                Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an
                uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung
                (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
              </p>
              <p className="mb-4">
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns
                zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
                für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage).
                Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Veranstaltungsfotos</h3>
              <p className="mb-4">
                Im Rahmen von Ausstellungen und Vernissagen werden Übersichtsaufnahmen der Veranstaltung
                angefertigt. Diese Fotos dienen der Dokumentation und Berichterstattung über das
                künstlerische Wirken und werden auf dieser Website veröffentlicht.
              </p>
              <p className="mb-4">
                Die Aufnahmen zeigen in der Regel das Veranstaltungsgeschehen und die ausgestellten Werke.
                Sollten dabei Personen erkennbar abgebildet sein, erfolgt die Verarbeitung auf Grundlage
                des berechtigten Interesses an der Öffentlichkeitsarbeit im Rahmen der künstlerischen Tätigkeit
                gemäß Art. 6 Abs. 1 lit. f DSGVO.
              </p>
              <p className="mb-4">
                Sofern Sie auf einem veröffentlichten Foto erkennbar abgebildet sind und der Veröffentlichung
                widersprechen möchten, wenden Sie sich bitte per E-Mail an{' '}
                <a href="mailto:info@gwiedemann.de" className="text-primary hover:text-secondary">
                  info@gwiedemann.de
                </a>
                . Das Foto wird dann unverzüglich entfernt.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Server-Log-Dateien</h3>
              <p className="mb-4">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
                Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="mb-4 list-disc pl-6">
                <li>Browsertyp und Browserversion</li>
                <li>Verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse</li>
              </ul>
              <p className="mb-4">
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
                Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien
                Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files
                erfasst werden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">4. Externe Dienste</h2>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">EmailJS</h3>
              <p className="mb-4">
                Diese Website nutzt EmailJS für den Versand von Kontaktformular-Nachrichten. Anbieter
                ist EmailJS.com (Email Service, Ltd., London, Vereinigtes Königreich).
              </p>
              <p className="mb-4">
                Wenn Sie das Kontaktformular nutzen, werden die von Ihnen eingegebenen Daten
                (Name, E-Mail-Adresse, Nachricht) an EmailJS übermittelt, um die E-Mail an uns zu
                versenden. EmailJS verarbeitet diese Daten ausschließlich zum Zweck der E-Mail-Zustellung.
              </p>
              <p className="mb-4">
                Die Nutzung von EmailJS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir
                haben ein berechtigtes Interesse an einer möglichst zuverlässigen Kontaktaufnahme
                über unsere Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt
                die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die
                Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="mb-4">
                Weitere Informationen finden Sie in der Datenschutzerklärung von EmailJS:
                <a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-secondary ml-1">
                  https://www.emailjs.com/legal/privacy-policy/
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">5. Ihre Rechte als betroffene Person</h2>
              <p className="mb-4">
                Sie haben nach der DSGVO verschiedene Rechte bezüglich Ihrer personenbezogenen Daten.
                Im Einzelnen:
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Auskunftsrecht (Art. 15 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende
                personenbezogene Daten verarbeitet werden; ist dies der Fall, so haben Sie ein Recht
                auf Auskunft über diese personenbezogenen Daten.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Recht auf Berichtigung (Art. 16 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger
                personenbezogener Daten zu verlangen.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Recht auf Löschung (Art. 17 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, zu verlangen, dass Sie betreffende personenbezogene Daten
                unverzüglich gelöscht werden, sofern einer der gesetzlich vorgesehenen Gründe zutrifft.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der
                in Art. 18 DSGVO aufgeführten Voraussetzungen gegeben ist.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten,
                gängigen und maschinenlesbaren Format zu erhalten.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Widerspruchsrecht (Art. 21 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
                jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten Widerspruch
                einzulegen.
              </p>

              <h3 className="text-xl font-semibold text-primary mb-3 mt-6">Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)</h3>
              <p className="mb-4">
                Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
                Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen
                Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
                personenbezogenen Daten gegen die DSGVO verstößt.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">6. Speicherdauer</h2>
              <p className="mb-4">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die
                Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen
                oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
                sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
                personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen);
                im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">7. Kontakt in Datenschutzfragen</h2>
              <p className="mb-4">
                Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder
                wenden Sie sich direkt an die für den Datenschutz verantwortliche Person:
              </p>
              <p className="mb-4">
                <strong>E-Mail:</strong> <a href="mailto:info@gwiedemann.de" className="text-primary hover:text-secondary">info@gwiedemann.de</a>
              </p>
            </section>

            <p className="text-sm text-neutral-600 mt-8 pt-6 border-t border-neutral-200">
              Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </Section>
    </>
  )
}
